import Core from '@hcm4all/frontend-core'
const Icons = Core.UI.SVG.Icons24

export default function Icon ({ name, ...props }) {
  const IconComponent = Icons[name]

  if (!IconComponent) {
    console.warn(`No icon found with name: ${name}`)
    return null
  }

  return <IconComponent {...props} />
}
